module.exports = __webpack_public_path__ + "img/20.5.COD.2312bf94.png";